interface TopBarProps {
  showIntro?: boolean;
}

const TopBar = ({ showIntro = false }: TopBarProps) => {
  return (
    <div className={`top-bar ${showIntro ? 'intro-topbar' : ''}`}>
      🎉 Free shipping on orders over €50 — Limited time only!
    </div>
  );
};

export default TopBar;
